import { Text, View } from "@react-pdf/renderer";
import styles from "./components/Styles";
import { Permit } from "../../models/Permit";
import Row from "./components/Row";
import Item from "./components/Item";
import Break from "./components/Break";
import HeaderText from "./components/HeaderText";

interface Props {
  permit: Permit;
}

const BoundariesPage = ({ permit }: Props) => {
  if (!permit) return null;

  return (
    <>
      <HeaderText title="BOUNDARIES" />
      {permit.areas?.map((b, i) =>
        (b.polygon.coordinates as number[][][]).map((ring, j) => (
          <>
            <View wrap={false}>
              <HeaderText />
              <Row border>
                <Item title={b.type.name} text={`${ring.map((c) => ` (${c[0]}, ${c[1]})`)}`} width="100%"></Item>
              </Row>
              {b.comments && (
                <Row border>
                  <Item width="100%" text={b.comments}></Item>
                </Row>
              )}
            </View>
            <Break height={5} />
          </>
        ))
      )}

      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => `${pageNumber} / ${totalPages}`} fixed />
    </>
  );
};

export default BoundariesPage;
